import { render, staticRenderFns } from "./ClientCashback.vue?vue&type=template&id=22f70ec2&scoped=true"
import script from "./ClientCashback.vue?vue&type=script&lang=js"
export * from "./ClientCashback.vue?vue&type=script&lang=js"
import style0 from "./ClientCashback.vue?vue&type=style&index=0&id=22f70ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f70ec2",
  null
  
)

export default component.exports